import { makeStyles } from 'tss-react/mui';
import { CHAT_FOOTER_HEIGHT } from '../../../../../ChatConfigViews/components/ChatContainerContent/utils/styles.const';
import { CHAT_HEADER_MAX_HEIGHT } from '../../../../../ChatHeaderTemplate/ChatHeaderTemplate';
import { ALTER_MESSAGE_TYPE_ACTIONS_MAX_HEIGHT } from '../ChatMessageAlterMessageTypeActions/ChatMessageAlterMessageTypeActions';

const CHAT_MESSAGES_CONTENT_HEIGHT = '366px';

export const useChatMessagesContentStyles = makeStyles()((theme) => ({
  header: {
    marginTop: '8px',
  },
  list: {
    height: CHAT_MESSAGES_CONTENT_HEIGHT,

    [theme.breakpoints.down('sm')]: {
      // TODO: ESSE -20 FOI POSTO POIS QUANDO O textArea TEM 3 ROWS ELE AUMENTA O TAMANHO DO CHAT E ISSO NÃO É DESEJADO
      height: `calc(100dvh - 20px - ${ALTER_MESSAGE_TYPE_ACTIONS_MAX_HEIGHT} - ${CHAT_HEADER_MAX_HEIGHT} - ${CHAT_FOOTER_HEIGHT})`,
    },
  },
  scrollableContent: {
    overscrollBehavior: 'contain',
  },
}));
